import React, { useState, useEffect } from 'react';
import {
  Card,
  CardBody,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { NotificationManager } from '../../../../../../components/common/react-notifications';

export default function Settings({
  integrationId,
  saveIntegration,
  channelDetails,
  existingSettings = {},
}) {
  const [settings, setSettings] = useState(channelDetails.settings || {
    clientId: '',
    clientSecret: '',
    tenantId: '',
  });
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (existingSettings && Object.keys(existingSettings).length > 0) {
      setSettings({
        clientId: existingSettings.clientId || '',
        clientSecret: existingSettings.clientSecret || '',
        tenantId: existingSettings.tenantId || '',
      });
    }
  }, [existingSettings]);

  const handleChange = (e) => {
    setSettings({
      ...settings,
      [e.target.name]: e.target.value,
    });
  };

  const handleSave = async () => {
    let detailts = channelDetails || {};
    detailts.settings = settings;
    saveIntegration({ channelDetails: detailts });
  };

  return (
    <Card className="mb-4">
      <CardBody>
        <div className="text-center mb-2">
          <h6>Register App in Microsoft Entra ID</h6>
        </div>
        <Separator className="mb-3" />
        <div className="mb-4 p-3" style={{ }}>

          <Row>
            <Col md={12}>
              <ol style={{ paddingLeft: 24, marginBottom: 0,listStyle: 'disc' }}>
                <li style={{ marginBottom: 24, lineHeight: 1.7 }}>
                  <span style={{ fontWeight: 600, color: '#2d3a4b', fontSize: 16 }}>STEP 1:</span>
                  <span style={{ fontWeight: 500, marginLeft: 8 }}>Register app in Microsoft Entra ID</span>
                  <ul style={{ marginTop: 10, marginBottom: 0, paddingLeft: 20, listStyle: '-moz-initial' }}>
                    <li style={{ marginBottom: 6 }}>Go to <b>Entra ID → App registrations</b></li>
                    <li style={{ marginBottom: 6 }}>Create a new app named <b>email-automation</b></li>
                    <li style={{ marginBottom: 6 }}>Add API permissions (Application type): <b>Mail.ReadWrite</b> and <b>Mail.Send</b></li>
                    <li style={{ marginBottom: 6 }}>Under <b>Certificates & secrets</b>, create a new client secret named <b>email-automation-secret</b></li>
                    <li style={{ marginBottom: 0 }}>Copy the <b>Tenant ID</b>, <b>Client ID</b>, and <b>Client Secret</b> to add them below in Step 4.</li>
                  </ul>
                </li>
                <li style={{ marginBottom: 24, lineHeight: 1.7 }}>
                  <span style={{ fontWeight: 600, color: '#2d3a4b', fontSize: 16 }}>STEP 2:</span>
                  <span style={{ fontWeight: 500, marginLeft: 8 }}>Create Application Access Policy <span style={{ fontWeight: 'normal', color: '#888' }}>(optional but recommended)</span></span>
                  <ul style={{ marginTop: 10, marginBottom: 0, paddingLeft: 20, listStyle: '-moz-initial'  }}>
                    <li style={{ marginBottom: 8 }}>This step restricts the app to access only specific mailboxes. Run the following PowerShell command:</li>
                    <pre style={{ background: '#f8f9fa', padding: '12px', borderRadius: '6px', fontSize: 13, marginTop: 8, marginBottom: 0, border: '1px solid #e3e6ed' }}>
{`New-ApplicationAccessPolicy -AppId <your-app-id> -PolicyScopeGroupId <email-automation-group> -AccessRight RestrictAccess -Description "Restrict to defined mailboxes"`}
                    </pre>
                  </ul>
                </li>
                <li style={{ marginBottom: 24, lineHeight: 1.7 }}>
                  <span style={{ fontWeight: 600, color: '#2d3a4b', fontSize: 16 }}>STEP 3:</span>
                  <span style={{ fontWeight: 500, marginLeft: 8 }}>Add your mailbox to the group</span>
                </li>
                <li style={{ marginBottom: 0, lineHeight: 1.7 }}>
                  <span style={{ fontWeight: 600, color: '#2d3a4b', fontSize: 16 }}>STEP 4:</span>
                  <span style={{ fontWeight: 500, marginLeft: 8 }}>Add credentials</span>
                  <ul style={{ marginTop: 10, marginBottom: 0, paddingLeft: 20, listStyle: '-moz-initial' }}>
                    <li>Paste the values from Step 1 below:</li>
                  </ul>
                </li>
              </ol>
            </Col>
          </Row>
        </div>
        <div className="text-center mb-2">
          <h6>Outlook Settings</h6>
        </div>
        <Separator className="mb-3" />
        <Form>
          <Row form>
            <Col md={12}>
              <FormGroup>
                <Label for="clientId">Client ID</Label>
                <Input
                  type="text"
                  name="clientId"
                  id="clientId"
                  placeholder="Enter Azure Client ID"
                  value={settings.clientId}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={12}>
              <FormGroup>
                <Label for="clientSecret">Client Secret</Label>
                <Input
                  type="text"
                  name="clientSecret"
                  id="clientSecret"
                  placeholder="Enter Azure Client Secret"
                  value={settings.clientSecret}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Row form>
            <Col md={12}>
              <FormGroup>
                <Label for="tenantId">Tenant ID</Label>
                <Input
                  type="text"
                  name="tenantId"
                  id="tenantId"
                  placeholder="Enter Azure Tenant ID"
                  value={settings.tenantId}
                  onChange={handleChange}
                />
              </FormGroup>
            </Col>
          </Row>

          <Separator className="mb-3" />
          <Colxx md="12" className="text-center">
            <Button
              color="primary"
              size="xs"
              onClick={handleSave}
              disabled={isLoading}
            >
              {isLoading ? 'Saving...' : 'Save'}
            </Button>
          </Colxx>
        </Form>
      </CardBody>
    </Card>
  );
}